const content = [
  {
    pflegegrad: 1,
    pflegegeld: 0,
    pflegesachleistungen: 0,
    entlastungsbetrag: 125,
    tagesundnachtpflege: 0,
    kurzzeitpflege: 0,
    verhinderungspflege: 0,
    pflegehilfsmittel: 40,
    hausnotruf: 25.5,
    wohnumfeldverbesserungen: 4000,
  },
  {
    pflegegrad: 2,
    pflegegeld: 316,
    pflegesachleistungen: 724,
    entlastungsbetrag: 125,
    tagesundnachtpflege: 689,
    kurzzeitpflege: 1774,
    verhinderungspflege: 1612,
    pflegehilfsmittel: 40,
    hausnotruf: 25.5,
    wohnumfeldverbesserungen: 4000,
  },
  {
    pflegegrad: 3,
    pflegegeld: 545,
    pflegesachleistungen: 1363,
    entlastungsbetrag: 125,
    tagesundnachtpflege: 1298,
    kurzzeitpflege: 1774,
    verhinderungspflege: 1612,
    pflegehilfsmittel: 40,
    hausnotruf: 25.5,
    wohnumfeldverbesserungen: 4000,
  },
  {
    pflegegrad: 4,
    pflegegeld: 728,
    pflegesachleistungen: 1693,
    entlastungsbetrag: 125,
    tagesundnachtpflege: 1612,
    kurzzeitpflege: 1774,
    verhinderungspflege: 1612,
    pflegehilfsmittel: 40,
    hausnotruf: 25.5,
    wohnumfeldverbesserungen: 4000,
  },
  {
    pflegegrad: 5,
    pflegegeld: 901,
    pflegesachleistungen: 2095,
    entlastungsbetrag: 125,
    tagesundnachtpflege: 1995,
    kurzzeitpflege: 1774,
    verhinderungspflege: 1612,
    pflegehilfsmittel: 40,
    hausnotruf: 25.5,
    wohnumfeldverbesserungen: 4000,
  },
];

const serviceInfos = [
  {
    label: 'pflegegeld',
    payout: 'monthly',
    pg1: false,
  },
  {
    label: 'pflegesachleistungen',
    payout: 'monthly',
    pg1: false,
  },
  {
    label: 'entlastungsbetrag',
    payout: 'monthly',
    pg1: true,
  },
  {
    label: 'tagesundnachtpflege',
    payout: 'monthly',
    pg1: false,
  },
  {
    label: 'kurzzeitpflege',
    payout: 'yearly',
    pg1: false,
  },
  {
    label: 'verhinderungspflege',
    payout: 'yearly',
    pg1: false,
  },
  {
    label: 'pflegehilfsmittel',
    payout: 'monthly',
    pg1: true,
  },
  {
    label: 'hausnotruf',
    payout: 'monthly',
    pg1: true,
  },
  {
    label: 'wohnumfeldverbesserungen',
    payout: 'one-time',
    pg1: true,
  },
];

export { serviceInfos };
export default content;
